import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { UsersService } from 'src/app/users/users.service';
import { StudiesService } from '../studies.service';

@Component({
	selector: 'app-studies-dashboard',
	templateUrl: './studies-dashboard.component.html',
	styleUrls: ['./studies-dashboard.component.css']
})
export class StudiesDashboardComponent {

	completedStudiesCount: number = 0;
	activeStudiesCount: number = 0;
	studyDevicesCount: number | null = null;

	get showDeviceCount(): boolean {
		return this.studyDevicesCount !== null;
	}

	constructor(
		private sideMenuService: SideMenuService,
		private usersService: UsersService,
		private router: Router,
		private studiesService: StudiesService
	) {}

	ngOnInit() {
		this.sideMenuService.hide();

		const currentUser = this.usersService.getCurrentUser();
		if (!currentUser.has_access_to_any_study)
			return this.router.navigate(['/unauthorized']);

		this.studiesService.getStudiesMetrics().subscribe((res: any) => {
			this.completedStudiesCount = res.completed_studies_count ?? 0;
			this.activeStudiesCount = res.active_studies_count ?? 0;
			this.studyDevicesCount = res.study_devices_count !== undefined ? res.study_devices_count : null;
		});
	}
}
